module.exports = __webpack_public_path__ + "img/avatar6.d7aaeaa4.png";